import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TdoTableSelectionEvent} from '../../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import {ConversionUtilities} from '../../../../utilities/conversion.utilities';
import {DataARLedgerListModel} from '../../models/data-ar-ledger-list.model';
import { LEDGER_ITEM_TYPE } from 'src/app/models/constants/ledger-item-type.model';
import { EnumARPaymentType } from 'src/app/models/enum/enum-ar-payment-type';

@Component({
  standalone: false,
  selector: 'app-ar-ledger-item-select',
  templateUrl: './ar-ledger-item-select.component.html',
  styleUrls: ['./ar-ledger-item-select.component.scss']
})
export class ArLedgerItemSelectComponent implements OnInit {

  isShowCredits: boolean = false;
  ledgerItem: DataARLedgerListModel;
  ledgerItems: DataARLedgerListModel[];
  isLoading: boolean = false;
  TZID: string = '';
  tzOffsetMins: number = 0;
  enumARLedgerItemOriginTypeTransaction: string = '00000207-1000-0000-0000-000000000003';
  enumARLedgerItemOriginTypePatient: string = '00000207-1000-0000-0000-000000000002';
  enumARLedgerItemOriginTypeInsurance: string = '00000207-1000-0000-0000-000000000001';
  type: string = '';

  constructor(
    public dialogRef: MatDialogRef<ArLedgerItemSelectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.ledgerItems = this.data.dataLedgerItems;
    if (this.data.isShowCredits != null) {
      this.isShowCredits = this.data.isShowCredits;
    }
    if (this.data.type != null) {
      this.type = this.data.type;
    }

    if (!this.isShowCredits) {
      if (this.type === 'checkreversal') {
        this.ledgerItems = this.ledgerItems.filter(a =>
          a.enumARPayementTypeID === EnumARPaymentType.Check
          && a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.CreditPayment);
      }
      else {
      this.ledgerItems = this.ledgerItems.filter(a =>
        a.dataARTransactionItemList?.Code
        && a.enumARLedgerItemOriginTypeID === this.enumARLedgerItemOriginTypePatient
        && a.enumARLedgerItemTypeID === LEDGER_ITEM_TYPE.Debit);
      }
    }
  }

  save() {
      this.close(this.ledgerItem);
  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    this.ledgerItem = event.model;
  }

  convertUTCDatetoTimezone(date: Date, tz: string) {
    date = ConversionUtilities.getAdjustedTimezoneDate(date, tz);
    return date;
  }
}
